// R116 #4 (Kai, MTR → Tenants: "please add option for notes so we can put
// proper documentation why payments are not logged yet and/or lease are not
// being extended … check by 15-17 for checks to clear. Edit option only allows
// you to edit monthly rate and lease term."): the Tenants tab, rebuilt in the
// Calendar stay panel's look and phone-first.
//   • a responsive grid of soft tenant CARDS (one column on a phone): avatar +
//     name + home, the rent chip (OWES / CLEARING · by Oct 17 / current / set
//     rent), the open follow-up pill ("⏰ check Oct 15–17 · now"), lease / rent /
//     on-time, the latest note ("💬 2 · …" or "＋ Add a note"), ONE inline action
//     (✓ <month> check cleared → one tap; else Log the owed month; else Rent &
//     notes) and the rest behind the shared ⋯;
//   • filter chips (All · Needs attention · Follow-ups · Clearing · Set rent ·
//     Past) and one blue "＋ Add tenant";
//   • the tab label carries the follow-ups that are due (MtrPage asks tabBadge());
//   • Rent & notes = the shared panel (shared/components/MtrRentLedger.ts);
//   • Edit = a sheet (rent, due day — re-dates due dates —, lease end; an AUTO
//     tenant's lease is read-only with "extend it in Hostaway") + an optional
//     "Why?" saved as a note in the SAME write (POST /api/mtr/tenants {…, note});
//   • remove is two-tap on the card and blocked (server 409) while notes exist.
// Writes answer the tenant view and are swapped in place (no roster reload);
// a roster reload that fails keeps what is on screen. No alert / confirm.
import { kebabHtml, bindKebabs, closeKebab, type KebabItem } from '../../shared/components/Kebab';
import { openRentLedgerModal, openMtrSheet } from '../../shared/components/MtrRentLedger';
import { esc, money, md, fmtFull, periodLabel, initials, chipOf, followText, followTone, localToday, type Tone } from '../../shared/lib/mtrTenant';

export interface TenantsHost {
  /** the GET /api/mtr/tenants payload MtrPage holds (or null) */
  data(): any;
  /** swap / add one tenant view (a write's answer) into the payload */
  applyTenant(v: any): void;
  /** drop a tenant from the payload */
  removeTenant(id: string): void;
  /** re-fetch the roster; false = failed (what is on screen stays) */
  reload(): Promise<boolean>;
  /** redraw the MTR page (tabs + this tab) */
  redraw(): void;
  whoName(by: string): string;
  loadPeople(): Promise<void>;
  toast(text: string): void;
}
type Filter = 'all' | 'attention' | 'followups' | 'clearing' | 'untracked' | 'past';
const FILTERS: Array<[Filter, string]> = [['all', 'All'], ['attention', 'Needs attention'], ['followups', 'Follow-ups'], ['clearing', 'Clearing'], ['untracked', 'Set rent'], ['past', 'Past']];

const CSS_ID = 'mtt-css';
const CSS = `
.mtt-head { display:flex; align-items:center; gap:10px; flex-wrap:wrap; margin-bottom:10px; }
.mtt-chips { display:flex; gap:6px; flex-wrap:wrap; flex:1; min-width:0; }
.mtt-chips .chip { min-height:32px; }
.mtt-chip-bad .chip-count { background:var(--danger-soft); color:var(--danger-text); }
.mtt-chip-warn .chip-count { background:var(--warning-soft); color:var(--warning-text); }
.mtt-sum { font-size:12px; color:var(--text-muted); line-height:1.55; margin:0 0 4px; }
.mtt-sum b { color:var(--text); font-weight:600; }
.mtt-sum .bad { color:var(--danger-text); font-weight:600; }
.mtt-sum .warn { color:var(--warning-text); font-weight:600; }
.mtt-basis { font-size:11px; color:var(--text-faint); line-height:1.5; margin:0 0 14px; }
.mtt-grid { display:grid; grid-template-columns:repeat(auto-fill, minmax(330px, 1fr)); gap:14px; align-items:stretch; }
.mtt-card { position:relative; display:flex; flex-direction:column; gap:10px; border:1px solid var(--border); border-radius:var(--radius); background:var(--card); box-shadow:var(--shadow-card); padding:14px; cursor:pointer; transition:box-shadow .12s ease, border-color .12s ease; min-width:0; }
.mtt-card:hover { border-color:var(--border-strong); box-shadow:var(--shadow-hover); }
.mtt-card:focus-visible { outline:none; border-color:var(--accent); box-shadow:var(--focus-ring); }
.mtt-card.tone-bad { box-shadow:inset 3px 0 0 var(--danger), var(--shadow-card); }
.mtt-card.tone-warn { box-shadow:inset 3px 0 0 var(--warning), var(--shadow-card); }
.mtt-card.past { opacity:.72; }
.mtt-top { display:flex; align-items:flex-start; gap:12px; }
.mtt-av { flex:none; width:40px; height:40px; border-radius:var(--radius-pill); background:var(--info-soft); color:var(--info-text); font-weight:700; font-size:14px; display:inline-flex; align-items:center; justify-content:center; }
.mtt-id { flex:1; min-width:0; }
.mtt-name { font-size:14.5px; font-weight:700; color:var(--text); line-height:1.3; overflow-wrap:anywhere; }
.mtt-home { font-size:12px; color:var(--text-muted); margin-top:2px; overflow-wrap:anywhere; }
.mtt-top .kb-btn { margin:-4px -6px 0 0; color:var(--text-muted); }
.mtt-pills { display:flex; flex-wrap:wrap; gap:6px; }
.mtt-pill { display:inline-flex; align-items:center; gap:4px; font-size:11px; font-weight:600; padding:3px 9px; border-radius:var(--radius-pill); white-space:nowrap; border:1px solid var(--border); background:var(--bg-subtle); color:var(--text-muted); line-height:1.4; max-width:100%; overflow:hidden; text-overflow:ellipsis; }
.mtt-pill.ok { background:var(--success-soft); color:var(--success-text); border-color:var(--success-border); }
.mtt-pill.warn { background:var(--warning-soft); color:var(--warning-text); border-color:var(--warning-border); }
.mtt-pill.bad { background:var(--danger-soft); color:var(--danger-text); border-color:var(--danger-border); }
.mtt-pill.muted { background:var(--card); }
.mtt-facts { display:grid; grid-template-columns:minmax(0, 1.3fr) minmax(0, 1fr) minmax(0, .7fr); gap:8px; padding-top:10px; border-top:1px solid var(--border-soft); }
.mtt-dl { font-size:10px; font-weight:700; letter-spacing:.08em; text-transform:uppercase; color:var(--text-faint); }
.mtt-dv { font-size:12.5px; font-weight:600; color:var(--text); margin-top:2px; font-variant-numeric:tabular-nums; overflow-wrap:anywhere; }
.mtt-dv small { font-weight:500; color:var(--text-muted); font-size:11px; }
.mtt-note { display:block; text-align:left; width:100%; border:1px solid var(--border-soft); background:var(--bg-subtle); border-radius:var(--radius-sm); padding:8px 10px; font:inherit; font-size:12px; line-height:1.45; color:var(--text-muted); cursor:pointer; overflow-wrap:anywhere; }
.mtt-note-t { display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; }
.mtt-note:hover { color:var(--text); border-color:var(--border); }
.mtt-note .n { font-weight:700; color:var(--text); }
.mtt-note.empty { background:none; border-style:dashed; color:var(--text-faint); }
.mtt-note.empty:hover { color:var(--accent); border-color:var(--accent-border); }
.mtt-acts { display:flex; gap:8px; margin-top:auto; }
.mtt-acts .btn { flex:1; justify-content:center; min-height:34px; }
.mtt-arm { display:flex; align-items:center; flex-wrap:wrap; gap:6px 10px; padding:8px 10px; border-radius:var(--radius-sm); background:var(--danger-soft); color:var(--danger-text); font-size:12px; cursor:default; }
.mtt-arm span { flex:1; min-width:140px; }
.mtt-arm .btn { min-height:32px; }
.mtt-err { padding:8px 10px; border-radius:var(--radius-sm); background:var(--danger-soft); color:var(--danger-text); font-size:12px; line-height:1.45; cursor:default; }
.mtt-empty { padding:28px 16px; text-align:center; color:var(--text-muted); border:1px dashed var(--border); border-radius:var(--radius); background:var(--card); font-size:12.5px; }
.mtr-tab .mtt-tabcnt { display:inline-flex; align-items:center; justify-content:center; min-width:18px; height:18px; padding:0 5px; margin-left:6px; border-radius:var(--radius-pill); font-size:10.5px; font-weight:700; background:var(--warning-soft); color:var(--warning-text); vertical-align:1px; }
.mtr-tab .mtt-tabcnt.bad { background:var(--danger-soft); color:var(--danger-text); }
/* the Edit / Add sheet */
.mtt-form { display:flex; flex-direction:column; gap:12px; }
.mtt-f { display:flex; flex-direction:column; gap:5px; font-size:10.5px; font-weight:600; color:var(--text-muted); text-transform:uppercase; letter-spacing:.05em; min-width:0; }
.mtt-f input, .mtt-f select, .mtt-f textarea { font:inherit; font-size:13.5px; text-transform:none; letter-spacing:0; font-weight:400; color:var(--text); padding:8px 10px; min-height:38px; border:1px solid var(--border); border-radius:var(--radius-sm); background:var(--card); box-sizing:border-box; width:100%; min-width:0; }
.mtt-f textarea { resize:vertical; min-height:72px; line-height:1.45; }
.mtt-f input:focus, .mtt-f select:focus, .mtt-f textarea:focus { outline:none; border-color:var(--accent); box-shadow:var(--focus-ring); }
.mtt-f input[readonly] { background:var(--bg-subtle); color:var(--text-muted); }
.mtt-f2 { display:grid; grid-template-columns:1fr 1fr; gap:10px; }
.mtt-hint { font-size:11.5px; color:var(--text-faint); line-height:1.5; text-transform:none; letter-spacing:0; font-weight:400; }
.mtt-lock { border:1px solid var(--border); border-radius:var(--radius); background:var(--card); padding:12px 14px; box-shadow:var(--shadow-card); }
.mtt-lock .mtt-dv { font-size:13.5px; }
.mtt-lock .mtt-hint b { color:var(--text-muted); }
.mtt-seg { display:flex; gap:6px; }
.mtt-foot { position:sticky; bottom:-20px; display:flex; justify-content:flex-end; gap:8px; padding:12px 0 4px; background:var(--bg); border-top:1px solid var(--border-soft); margin-top:4px; }
.mtt-foot .btn { min-height:38px; padding:9px 16px; }
@media (max-width: 640px) {
  .mtt-grid { grid-template-columns:minmax(0, 1fr); gap:12px; }
  .mtt-chips { flex-wrap:nowrap; overflow-x:auto; scrollbar-width:none; flex:1 1 100%; order:2; padding-bottom:2px; }
  .mtt-chips::-webkit-scrollbar { display:none; }
  .mtt-chips .chip { flex:none; min-height:36px; }
  .mtt-head .mtt-add { margin-left:auto; }
  .mtt-acts .btn, .mtt-arm .btn { min-height:38px; }
  .mtt-note { padding:10px; }
  .mtt-top .kb-btn { min-width:36px; height:36px; margin:-6px -8px 0 0; }
  .mtt-f input, .mtt-f select, .mtt-f textarea { font-size:16px; }
  .mtt-f2 { grid-template-columns:1fr 1fr; }
  .mtt-foot { bottom:-20px; }
  .mtt-foot .btn { flex:1; justify-content:center; }
}
`;
function ensureCss(): void {
  if (document.getElementById(CSS_ID)) return;
  const st = document.createElement('style');
  st.id = CSS_ID; st.textContent = CSS;
  document.head.appendChild(st);
}
const pill = (tone: string, text: string, title = '') => `<span class="mtt-pill ${esc(tone)}"${title ? ` title="${esc(title)}"` : ''}>${esc(text)}</span>`;
const isClearing = (p: any) => !!p && p.status === 'clearing';

/** client-side summary — recomputed after every in-place swap so the header never lags a write */
export function summarize(tenants: any[]): { active: number; tracked: number; owed: number; clearing: number; clearingTenants: number; untracked: number; fuOpen: number; fuDue: number; fuOverdue: number } {
  const act = tenants.filter(t => t && t.status === 'active');
  const s = { active: act.length, tracked: 0, owed: 0, clearing: 0, clearingTenants: 0, untracked: 0, fuOpen: 0, fuDue: 0, fuOverdue: 0 };
  for (const t of act) { if (t.monthly_amount != null) s.tracked += Number(t.monthly_amount) || 0; else s.untracked++; }
  for (const t of tenants) {
    if (!t) continue;
    const ps = t.payment_status || {};
    s.owed += Number(ps.owed_amount) || 0;
    s.clearing += Number(ps.clearing_amount) || 0;
    if ((ps.clearing_count || 0) > 0) s.clearingTenants++;
    const f = t.follow_ups || {};
    s.fuOpen += f.open || 0; s.fuDue += f.due || 0; s.fuOverdue += f.overdue || 0;
  }
  return s;
}

export class MtrTenantsTab {
  private filter: Filter = 'all';
  private armed: string | null = null;      // a card's two-tap "Remove?"
  private cardErr: { id: string; msg: string } | null = null;
  private saving = new Set<string>();
  private sheets = 0;                         // open Edit / Add sheets
  private panel: { id: string; dirty: () => boolean; redraw: () => void } | null = null;
  private peopleAsked = false;

  constructor(private host: TenantsHost) {}

  private tenants(): any[] { const d = this.host.data(); return d && Array.isArray(d.tenants) ? d.tenants : []; }
  private find(id: string): any { return this.tenants().find((t: any) => t && t.id === id) || null; }

  /** the 15-min auto-refresh veto: a sheet or the panel is open (a refresh would swap the roster under it — the list rows
   *  carry no history), or a card write is still saving */
  busy(): boolean { return this.sheets > 0 || !!this.panel || this.saving.size > 0; }

  /** the Tenants tab label's count: follow-ups that are due (now + overdue) */
  tabBadge(): string {
    ensureCss();
    if (!this.host.data()) return '';
    const s = summarize(this.tenants());
    if (!s.fuDue) return '';
    return ` <span class="mtt-tabcnt${s.fuOverdue ? ' bad' : ''}" title="${s.fuDue} tenant follow-up${s.fuDue === 1 ? '' : 's'} due${s.fuOverdue ? ` (${s.fuOverdue} overdue)` : ''}">${s.fuDue}</span>`;
  }

  private matches(t: any, f: Filter): boolean {
    const ps = t.payment_status || {};
    const fu = t.follow_ups || {};
    if (f === 'past') return t.status === 'past';
    if (t.status === 'past') return false;
    if (f === 'all') return true;
    if (f === 'followups') return (fu.open || 0) > 0;
    if (f === 'clearing') return (Array.isArray(ps.clearing) && ps.clearing.length > 0);
    if (f === 'untracked') return t.monthly_amount == null;
    return (ps.owed_count || 0) > 0 || (ps.clearing_count || 0) > 0 || (fu.due || 0) > 0;   // attention
  }

  render(): string {
    ensureCss();
    if (!this.peopleAsked) { this.peopleAsked = true; void this.host.loadPeople().then(() => this.host.redraw()).catch(() => { /* names fall back to the email */ }); }
    const d = this.host.data();
    if (!d) return `<div class="mtt-empty">Tenants couldn’t load just now — ↻ refresh the page to try again.</div>`;
    const all = this.tenants();
    const s = summarize(all);
    const counts = Object.fromEntries(FILTERS.map(([k]) => [k, all.filter(t => this.matches(t, k)).length])) as Record<Filter, number>;
    // what needs someone first (owed / an overdue follow-up → a check clearing / a follow-up due now → rent not set), else the server's order
    const rank = (t: any) => {
      const ps = t.payment_status || {}, f = t.follow_up;
      if ((ps.owed_count || 0) > 0 || (f && f.tone === 'overdue') || (ps.chip && ps.chip.tone === 'bad')) return 0;
      if ((ps.clearing_count || 0) > 0 || (f && f.tone === 'now')) return 1;
      if (t.monthly_amount == null && t.status === 'active') return 2;
      return 3;
    };
    const list = all.map((t, i) => ({ t, i, r: rank(t) })).filter(x => this.matches(x.t, this.filter)).sort((a, b) => a.r - b.r || a.i - b.i).map(x => x.t);
    const chip = ([k, label]: [Filter, string]) => {
      const tone = k === 'attention' && counts.attention ? ' mtt-chip-bad' : k === 'followups' && s.fuDue ? (s.fuOverdue ? ' mtt-chip-bad' : ' mtt-chip-warn') : k === 'clearing' && counts.clearing ? ' mtt-chip-warn' : '';
      return `<button type="button" class="chip${this.filter === k ? ' active' : ''}${tone}" data-mtt-filter="${k}" aria-pressed="${this.filter === k ? 'true' : 'false'}">${esc(label)} <span class="chip-count">${counts[k]}</span></button>`;
    };
    const parts = [
      `As of <b>${esc(md(d.as_of))}</b>`, `<b>${s.active}</b> active`, `<b>${money(s.tracked)}</b>/mo tracked`,
      s.owed ? `<span class="bad">${money(s.owed)} owed now</span>` : '',
      s.clearing ? `<span class="warn">${money(s.clearing)} clearing</span>` : '',
      s.fuDue ? `<span class="${s.fuOverdue ? 'bad' : 'warn'}">${s.fuDue} follow-up${s.fuDue === 1 ? '' : 's'} due</span>` : (s.fuOpen ? `${s.fuOpen} follow-up${s.fuOpen === 1 ? '' : 's'} open` : ''),
      s.untracked ? `${s.untracked} need a rent amount` : '',
    ].filter(Boolean);
    const emptyMsg = this.filter === 'all'
      ? 'No tenants yet. In-house mid-term bookings (28+ nights) appear here automatically; add a direct-lease tenant with ＋ Add tenant.'
      : 'Nothing here right now.';
    return `
      <div class="mtt-head">
        <div class="mtt-chips" role="toolbar" aria-label="Filter tenants">${FILTERS.map(chip).join('')}</div>
        <button type="button" class="btn btn-primary btn-sm mtt-add" data-mtt-add>＋ Add tenant</button>
      </div>
      <p class="mtt-sum">${parts.join(' · ')}</p>
      <p class="mtt-basis">${esc(d.basis || '')}</p>
      ${list.length ? `<div class="mtt-grid">${list.map(t => this.card(t)).join('')}</div>` : `<div class="mtt-empty">${esc(emptyMsg)}</div>`}`;
  }

  private card(t: any): string {
    const ps = t.payment_status || {};
    const chipV = chipOf(ps, !!t.unsaved);
    const fu = t.follow_up || null;
    const id = String(t.id);
    const clearing = (Array.isArray(t.payments) ? t.payments : []).filter(isClearing).sort((a: any, b: any) => String(a.expected_clear || '9').localeCompare(String(b.expected_clear || '9')))[0] || null;
    const owedFirst = Array.isArray(ps.owed) && ps.owed.length ? ps.owed[0] : null;
    const tone: Tone = chipV.tone === 'bad' || (fu && fu.tone === 'overdue') ? 'bad' : chipV.tone === 'warn' || (fu && fu.tone === 'now') ? 'warn' : 'muted';
    const busy = this.saving.has(id);
    const primary = clearing
      ? `<button type="button" class="btn btn-secondary btn-sm" data-mtt-clear="${esc(id)}|${esc(clearing.id)}"${busy ? ' disabled' : ''}>${busy ? 'Saving…' : `✓ ${esc(periodLabel(clearing.period))} check cleared`}</button>`
      : owedFirst
        ? `<button type="button" class="btn btn-secondary btn-sm" data-mtt-open="${esc(id)}|pay">Log the ${esc(periodLabel(owedFirst))} payment</button>`
        : `<button type="button" class="btn btn-secondary btn-sm" data-mtt-open="${esc(id)}">Rent &amp; notes</button>`;
    const nCount = Number(t.notes_count) || 0;
    const nWord = nCount === 1 ? 'note' : 'notes';
    const items: KebabItem[] = [
      { icon: '💲', label: 'Rent & notes', attrs: { 'data-mtt-open': id } },
      { icon: '📝', label: 'Add a note', attrs: { 'data-mtt-open': `${id}|note` } },
      { icon: '＋', label: 'Log a payment', attrs: { 'data-mtt-open': `${id}|pay` } },
      { icon: '✎', label: 'Edit rent & lease…', attrs: { 'data-mtt-edit': id } },
      { divider: true },
      nCount
        ? { icon: '✕', label: `Remove tenant (has ${nCount} ${nWord})`, disabled: true, title: 'Delete the notes first — or keep the record: an ended tenancy goes “past” on its own.' }
        : { icon: '✕', label: 'Remove tenant…', danger: true, attrs: { 'data-mtt-del': id } },
    ];
    const latest = t.latest_note;
    const noteRow = nCount && latest
      ? `<button type="button" class="mtt-note" data-mtt-open="${esc(id)}|note" title="Latest note — ${esc(latest.by ? this.host.whoName(latest.by) : 'author not recorded')}"><span class="mtt-note-t"><span class="n">💬 ${nCount}</span> · ${latest.period ? `${esc(periodLabel(latest.period))}: ` : ''}“${esc(latest.snippet)}”</span></button>`
      : `<button type="button" class="mtt-note empty" data-mtt-open="${esc(id)}|note"><span class="mtt-note-t">＋ Add a note — why rent isn’t logged, why the lease isn’t extended…</span></button>`;
    const onTime = (ps.on_time || ps.late) ? `${ps.on_time || 0} <small>of ${(ps.on_time || 0) + (ps.late || 0)}</small>` : '<small>—</small>';
    const arm = this.armed === id
      ? `<div class="mtt-arm" role="alert" data-mtt-stop><span>Remove ${esc(t.name)}? The payment history goes with it.${t.source === 'auto' ? ' (From a booking — it comes back while the booking is in-house.)' : ''}</span><button type="button" class="btn btn-ghost btn-sm" data-mtt-keep>Keep</button><button type="button" class="btn btn-danger btn-sm" data-mtt-delyes="${esc(id)}">Remove</button></div>` : '';
    const err = this.cardErr && this.cardErr.id === id ? `<div class="mtt-err" role="alert" data-mtt-stop>${esc(this.cardErr.msg)}</div>` : '';
    return `<article class="mtt-card${tone !== 'muted' ? ` tone-${tone}` : ''}${t.status === 'past' ? ' past' : ''}" data-mtt-card="${esc(id)}" tabindex="0" aria-label="${esc(t.name)} — open rent and notes">
      <div class="mtt-top">
        <span class="mtt-av" aria-hidden="true">${esc(initials(t.name))}</span>
        <div class="mtt-id"><div class="mtt-name">${esc(t.name)}</div><div class="mtt-home">${esc(t.listing_name || 'Home')} · ${t.source === 'auto' ? 'from the booking' : 'direct lease'}${t.status === 'past' ? ' · past' : ''}</div></div>
        ${kebabHtml(items, { tip: 'Tenant actions' })}
      </div>
      <div class="mtt-pills">${pill(chipV.tone, chipV.label, chipV.title)}${fu ? pill(followTone(fu.tone), followText(fu), 'open follow-up — tap the card to check it off') : ''}${!fu && ps.next_due && chipV.tone === 'ok' ? pill('muted', `next due ${md(ps.next_due)}`) : ''}</div>
      <div class="mtt-facts">
        <div><div class="mtt-dl">Lease</div><div class="mtt-dv">${esc(md(t.lease_start))} → ${t.lease_end ? esc(md(t.lease_end)) : 'open'}</div></div>
        <div><div class="mtt-dl">Rent</div><div class="mtt-dv">${t.monthly_amount != null ? `${money(t.monthly_amount)} <small>· day ${esc(t.due_day || 1)}</small>` : '<small>not set</small>'}</div></div>
        <div><div class="mtt-dl">On time</div><div class="mtt-dv">${onTime}</div></div>
      </div>
      ${noteRow}
      ${err}${arm}
      <div class="mtt-acts">${primary}</div>
    </article>`;
  }

  /** bound after every MtrPage draw (root = #mtr-body) */
  bind(root: HTMLElement): void {
    const on = (sel: string, fn: (el: HTMLElement, e: Event) => void) => root.querySelectorAll<HTMLElement>(sel).forEach(el => el.addEventListener('click', (e) => { e.stopPropagation(); closeKebab(); fn(el, e); }));
    on('[data-mtt-filter]', (el) => { this.filter = el.dataset.mttFilter as Filter; this.armed = null; this.host.redraw(); });
    on('[data-mtt-add]', () => this.openAdd());
    on('[data-mtt-open]', (el) => { const [id, what] = el.dataset.mttOpen!.split('|'); this.openPanel(id, what === 'note' ? 'note' : what === 'pay' ? 'pay' : undefined); });
    on('[data-mtt-edit]', (el) => this.openEdit(el.dataset.mttEdit!));
    on('[data-mtt-del]', (el) => { this.armed = el.dataset.mttDel!; this.cardErr = null; setTimeout(() => this.host.redraw(), 0); });
    on('[data-mtt-keep]', () => { this.armed = null; this.host.redraw(); });
    on('[data-mtt-delyes]', (el) => { void this.remove(el.dataset.mttDelyes!); });
    on('[data-mtt-clear]', (el) => { const [id, pid] = el.dataset.mttClear!.split('|'); void this.cleared(id, pid); });
    root.querySelectorAll<HTMLElement>('[data-mtt-stop]').forEach(el => el.addEventListener('click', (e) => e.stopPropagation()));
    root.querySelectorAll<HTMLElement>('[data-mtt-card]').forEach(card => {
      card.addEventListener('click', (e) => {
        if ((e.target as HTMLElement).closest('button, a, input, select, textarea, [data-kebab]')) return;
        this.openPanel(card.dataset.mttCard!);
      });
      card.addEventListener('keydown', (e) => { if (e.target === card && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); this.openPanel(card.dataset.mttCard!); } });
    });
    bindKebabs(root);
  }

  // ── the shared panel ──────────────────────────────────────────────────────
  openPanel(id: string, focus?: 'note' | 'pay'): void {
    const t0 = this.find(id);
    if (!t0) return;
    const m = openRentLedgerModal({
      tenantId: id,
      getTenant: () => this.find(id),
      refresh: () => this.fetchOne(id),
      applyTenant: (v) => { this.host.applyTenant(v); this.host.redraw(); },
      whoName: (by) => this.host.whoName(by),
      focus,
      onClose: () => { if (this.panel && this.panel.id === id) this.panel = null; },
    });
    // the 15-min refresh veto reads the panel's own dirtiness (its modal asks before discarding)
    this.panel = { id, dirty: m.isDirty, redraw: m.redraw };
    // the list row carries no history — fetch the full view (a read; never writes)
    void this.fetchOne(id).then(() => m.redraw()).catch(() => { /* the row is still shown */ });
  }
  private async fetchOne(id: string): Promise<void> {
    const r = await fetch(`/api/mtr/tenants/${encodeURIComponent(id)}`).catch(() => null);
    if (!r || !r.ok) return;
    const j = await r.json().catch(() => null);
    if (j && j.id === id) { this.host.applyTenant(j); this.host.redraw(); }
  }

  private async cleared(id: string, pid: string): Promise<void> {
    if (this.saving.has(id)) return;
    this.saving.add(id); this.cardErr = null; this.host.redraw();
    const r = await this.send('PUT', `/tenants/${encodeURIComponent(id)}/payment/${encodeURIComponent(pid)}`, { cleared: true });
    this.saving.delete(id);
    if (r.ok && r.j.tenant) { this.host.applyTenant(r.j.tenant); this.host.toast('Marked cleared — that month counts as paid now.'); }
    else this.cardErr = { id, msg: r.j.error || 'Couldn’t mark it cleared — try again.' };
    this.host.redraw();
  }
  private async remove(id: string): Promise<void> {
    if (this.saving.has(id)) return;
    this.saving.add(id); this.host.redraw();
    const r = await this.send('POST', '/tenants', { id, _delete: true });
    this.saving.delete(id);
    this.armed = null;
    if (r.ok) { this.host.removeTenant(id); this.host.toast('Tenant removed.'); }
    else this.cardErr = { id, msg: r.j.error || `Couldn’t remove the tenant (${r.status || 'network'}).` };
    this.host.redraw();
  }
  private async send(method: 'POST' | 'PUT', path: string, body: unknown): Promise<{ ok: boolean; status: number; j: any }> {
    try {
      const r = await fetch(`/api/mtr${path}`, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      const j = await r.json().catch(() => ({}));
      return { ok: r.ok, status: r.status, j: j || {} };
    } catch { return { ok: false, status: 0, j: { error: 'Network error — nothing was saved.' } }; }
  }

  // ── the Edit sheet (and Add) ──────────────────────────────────────────────
  openEdit(id: string): void {
    const t = this.find(id);
    if (!t) return;
    const auto = t.source === 'auto';
    const listings: any[] = (this.host.data() && this.host.data().listings) || [];
    const homeOpts = (sel: string) => {
      const ls = listings.length ? listings : [{ id: t.listing_id, name: t.listing_name || t.listing_id }];
      const has = ls.some(l => String(l.id) === String(sel));
      return (has ? '' : `<option value="${esc(sel)}" selected>${esc(t.listing_name || sel)}</option>`) + ls.map(l => `<option value="${esc(l.id)}"${String(l.id) === String(sel) ? ' selected' : ''}>${esc(l.name)}</option>`).join('');
    };
    const lease = auto
      ? `<div class="mtt-lock">
          <div class="mtt-dl">Lease · from the Hostaway booking${t.confirmation_code ? ` ${esc(t.confirmation_code)}` : ''}</div>
          <div class="mtt-dv">${esc(fmtFull(t.lease_start))} → ${t.lease_end ? esc(fmtFull(t.lease_end)) : 'open-ended'}</div>
          <div class="mtt-hint" style="margin-top:6px;">The lease follows the booking — <b>extend it in Hostaway</b> (it updates here on the next refresh). If it isn’t being extended yet, say why in the note below.</div>
        </div>`
      : `<label class="mtt-f">Tenant name<input name="name" value="${esc(t.name)}" autocomplete="off"></label>
        <label class="mtt-f">Home<select name="listing_id">${homeOpts(t.listing_id)}</select></label>
        <div class="mtt-f2">
          <label class="mtt-f">Lease start<input type="date" name="lease_start" value="${esc(t.lease_start || '')}"></label>
          <label class="mtt-f">Lease end<input type="date" name="lease_end" value="${esc(t.lease_end || '')}"><span class="mtt-hint">empty = open-ended</span></label>
        </div>
        <div class="mtt-f">Status<div class="mtt-seg">${['active', 'past'].map(s => `<button type="button" class="chip${t.status === s ? ' active' : ''}" data-mtt-status="${s}" aria-pressed="${t.status === s ? 'true' : 'false'}">${s === 'active' ? 'Active' : 'Past'}</button>`).join('')}</div></div>`;
    const html = `<form class="mtt-form" novalidate>
      ${lease}
      <div class="mtt-f2">
        <label class="mtt-f">Rent $/mo<input type="number" inputmode="decimal" min="0" step="1" name="monthly_amount" value="${esc(t.monthly_amount ?? '')}" placeholder="not set" data-autofocus></label>
        <label class="mtt-f">Due day<input type="number" inputmode="numeric" min="1" max="31" step="1" name="due_day" value="${esc(t.due_day || 1)}"></label>
      </div>
      <div class="mtt-hint">Changing the due day re-dates every logged month’s due date and re-scores on-time.</div>
      <label class="mtt-f">Why? <span class="mtt-hint">(optional — saved as a note with this change)</span><textarea name="note" maxlength="4000" placeholder="e.g. Owner approved the new rate · lease not extended yet: waiting on the renter’s new start date"></textarea></label>
      <div class="mtt-err" data-mtt-ferr hidden></div>
      <div class="mtt-foot"><button type="button" class="btn btn-ghost" data-mtt-cancel>Cancel</button><button type="submit" class="btn btn-primary" data-mtt-save>Save</button></div>
    </form>`;
    let touched = false;
    let status = String(t.status || 'active');
    this.sheets++;
    const sheet = openMtrSheet({ title: t.name, sub: `Edit rent & lease · ${t.listing_name || 'Home'}`, avatar: initials(t.name), label: 'Edit tenant', isDirty: () => touched, onClose: () => { this.sheets = Math.max(0, this.sheets - 1); } });
    sheet.body.innerHTML = html;
    const form = sheet.body.querySelector<HTMLFormElement>('form')!;
    const errBox = form.querySelector<HTMLElement>('[data-mtt-ferr]')!;
    const setErr = (m: string) => { errBox.textContent = m; errBox.hidden = !m; };
    form.addEventListener('input', () => { touched = true; });
    form.querySelectorAll<HTMLElement>('[data-mtt-status]').forEach(b => b.addEventListener('click', () => {
      status = b.dataset.mttStatus!; touched = true;
      form.querySelectorAll<HTMLElement>('[data-mtt-status]').forEach(x => { const on = x.dataset.mttStatus === status; x.classList.toggle('active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    }));
    form.querySelector('[data-mtt-cancel]')?.addEventListener('click', () => sheet.close(true));
    const v = (n: string) => String((form.elements.namedItem(n) as HTMLInputElement | null)?.value ?? '').trim();
    form.addEventListener('submit', async (ev) => {
      ev.preventDefault();
      const btn = form.querySelector<HTMLButtonElement>('[data-mtt-save]')!;
      if (btn.disabled) return;
      const amtRaw = v('monthly_amount').replace(/[$,\s]/g, '');
      if (amtRaw && !(Number(amtRaw) >= 0)) { setErr('Rent must be a number (e.g. 8250) — or empty to clear it.'); return; }
      const due = Number(v('due_day'));
      if (!Number.isInteger(due) || due < 1 || due > 31) { setErr('The due day is a whole number from 1 to 31.'); return; }
      const body: Record<string, unknown> = { id: t.id, monthly_amount: amtRaw === '' ? null : Number(amtRaw), due_day: due };
      if (!auto) {
        if (!v('name')) { setErr('The tenant needs a name.'); return; }
        if (!v('lease_start')) { setErr('Pick the lease start.'); return; }
        if (v('lease_end') && v('lease_end') < v('lease_start')) { setErr('The lease ends before it starts.'); return; }
        Object.assign(body, { name: v('name'), listing_id: v('listing_id') || t.listing_id, lease_start: v('lease_start'), lease_end: v('lease_end') || null, status });
      }
      if (v('note')) body.note = v('note');
      btn.disabled = true; btn.textContent = 'Saving…'; setErr('');
      const r = await this.send('POST', '/tenants', body);
      if (!r.ok) { btn.disabled = false; btn.textContent = 'Save'; setErr(r.j.error || `Not saved (${r.status || 'network'}).`); return; }
      if (r.j && r.j.id) this.host.applyTenant(r.j);
      sheet.close(true);
      this.host.toast(v('note') ? 'Saved — the reason is on the tenant’s notes.' : 'Saved.');
      this.host.redraw();
    });
    setTimeout(() => form.querySelector<HTMLElement>('[data-autofocus]')?.focus(), 30);
  }

  openAdd(): void {
    const listings: any[] = (this.host.data() && this.host.data().listings) || [];
    const html = `<form class="mtt-form" novalidate>
      <label class="mtt-f">Tenant name<input name="name" placeholder="name or company" autocomplete="off" data-autofocus></label>
      <label class="mtt-f">Home<select name="listing_id"><option value="">— pick the home —</option>${listings.map(l => `<option value="${esc(l.id)}">${esc(l.name)}</option>`).join('')}</select></label>
      <div class="mtt-f2">
        <label class="mtt-f">Lease start<input type="date" name="lease_start" value="${esc(localToday())}"></label>
        <label class="mtt-f">Lease end<input type="date" name="lease_end"><span class="mtt-hint">empty = open-ended</span></label>
      </div>
      <div class="mtt-f2">
        <label class="mtt-f">Rent $/mo<input type="number" inputmode="decimal" min="0" name="monthly_amount" placeholder="optional"></label>
        <label class="mtt-f">Due day<input type="number" inputmode="numeric" min="1" max="31" name="due_day" value="1"></label>
      </div>
      <label class="mtt-f">First note <span class="mtt-hint">(optional)</span><textarea name="note" maxlength="4000" placeholder="Anything the team should know — deposit, how they pay, who to call…"></textarea></label>
      <div class="mtt-hint">For a direct lease that isn’t a Hostaway booking — mid-term bookings (28+ nights) appear on their own.</div>
      <div class="mtt-err" data-mtt-ferr hidden></div>
      <div class="mtt-foot"><button type="button" class="btn btn-ghost" data-mtt-cancel>Cancel</button><button type="submit" class="btn btn-primary" data-mtt-save>Add tenant</button></div>
    </form>`;
    let touched = false;
    this.sheets++;
    const sheet = openMtrSheet({ title: 'Add a tenant', sub: 'Direct lease', avatar: '＋', label: 'Add tenant', isDirty: () => touched, onClose: () => { this.sheets = Math.max(0, this.sheets - 1); } });
    sheet.body.innerHTML = html;
    const form = sheet.body.querySelector<HTMLFormElement>('form')!;
    const errBox = form.querySelector<HTMLElement>('[data-mtt-ferr]')!;
    const setErr = (m: string) => { errBox.textContent = m; errBox.hidden = !m; };
    form.addEventListener('input', () => { touched = true; });
    form.querySelector('[data-mtt-cancel]')?.addEventListener('click', () => sheet.close(true));
    const v = (n: string) => String((form.elements.namedItem(n) as HTMLInputElement | null)?.value ?? '').trim();
    form.addEventListener('submit', async (ev) => {
      ev.preventDefault();
      const btn = form.querySelector<HTMLButtonElement>('[data-mtt-save]')!;
      if (btn.disabled) return;
      if (!v('name')) { setErr('The tenant needs a name.'); return; }
      if (!v('listing_id')) { setErr('Pick the home.'); return; }
      if (!v('lease_start')) { setErr('Pick the lease start.'); return; }
      if (v('lease_end') && v('lease_end') < v('lease_start')) { setErr('The lease ends before it starts.'); return; }
      const amtRaw = v('monthly_amount').replace(/[$,\s]/g, '');
      if (amtRaw && !(Number(amtRaw) >= 0)) { setErr('Rent must be a number (e.g. 3500).'); return; }
      btn.disabled = true; btn.textContent = 'Adding…'; setErr('');
      const r = await this.send('POST', '/tenants', { name: v('name'), listing_id: v('listing_id'), lease_start: v('lease_start'), lease_end: v('lease_end') || null, monthly_amount: amtRaw === '' ? null : Number(amtRaw), due_day: v('due_day') || 1, ...(v('note') ? { note: v('note') } : {}) });
      if (!r.ok) { btn.disabled = false; btn.textContent = 'Add tenant'; setErr(r.j.error || `Not saved (${r.status || 'network'}).`); return; }
      if (r.j && r.j.id) this.host.applyTenant(r.j);
      sheet.close(true);
      this.host.toast(`${v('name')} added.`);
      this.filter = 'all';
      this.host.redraw();
      void this.host.reload().then(ok => { if (ok) this.host.redraw(); });
    });
    setTimeout(() => form.querySelector<HTMLElement>('[data-autofocus]')?.focus(), 30);
  }
}
